import React from 'react'
import { dateformat, num, parseText } from 'components/_utils'
import './styles.scss'
import { regionnames } from '../regionnames'
export const Tooltip = ({
  pos,
  data,
  parentsize
}: {
  pos: { x: number; y: number }
  data: dataElement
  parentsize: {
    bottom: number
    height: number
    left: number
    right: number
    top: number
    width: number
    x: number
    y: number
  }
}) => {
  const { val, name, cum7, cum, date, id } = data
  let posinwindow = 'middle'
  if (parentsize) {
    if (parentsize.width * 0.4 > pos.x) posinwindow = 'left'
    if (parentsize.width * 0.6 < pos.x) posinwindow = 'right'
  }
  return (
    <div
      className={'Tooltip ' + (posinwindow || '')}
      style={{ left: pos.x, top: pos.y }}
    >
      <table>
        <tbody>
          <tr className='name'>
            <td colSpan={2}>{regionnames[id] ? regionnames[id] : name}</td>
          </tr>
          <tr className='inzidence'>
            <td>7-Tage-Inzidenz:</td>
            <td>{val}</td>
          </tr>
          <tr className='cases7'>
            <td>Bestätigte Fälle in 7 Tagen: </td>
            <td>{num(+cum7)}</td>
          </tr>
          <tr className='cases'>
            <td>Bestätigte Fälle total: </td>
            <td>{num(+cum)}</td>
          </tr>
          <tr className='date'>
            <td>Stand: </td>
            <td>{dateformat(date)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
